import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import { heading2 } from 'app/sofia/resources/theme/css'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { BP } from 'resources/constants'

export const Container = styled.div`
  padding: 0 0 20px;
  margin: 0 0 10px;
  z-index: 1;

  @media (min-width: ${BP.sm.min}) {
    margin: 0 0 40px;
  }

  @media (min-width: ${BP.md.min}) {
    padding: 0 0 50px;
    margin: 0 0 40px;
  }

  > div {
    ${containerCss}
  }

  h2 {
    ${heading2};
    text-align: center;
    margin: 0 0 20px;
    line-height: 1.2;

    @media (min-width: ${BP.sm.min}) {
      margin: 0 0 40px;
    }

    @media (min-width: ${BP.md.min}) {
      margin: 0 0 50px;
    }
  }

  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    align-items: center;

    li {
      margin: 15px 10px;
      ${bp('sm')`
        margin: 4% 2%;
      `}

      a {
        display: flex;
        padding: 35px 20px;
        background: ${props => props.theme.palette.general.light};
        height: 115px;
        width: 180px;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        border-radius: 5px;
        box-shadow: 0 3px 27px rgba(56, 41, 30, 0.19);
        transition: all ease-in-out 0.3s;
        ${bp('sm')`
          height: 90px;
          width: 155px;
          padding: 30px 15px;
        `}

        &:hover {
          box-shadow: 0 13px 25px rgba(56, 41, 30, 0.19);
          transform: scale(1.05, 1.05);
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
`
